import { render, staticRenderFns } from "./AppVideo.vue?vue&type=template&id=e5a8a3ca&"
import script from "./AppVideo.vue?vue&type=script&lang=js&"
export * from "./AppVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports